import React from 'react'
import { useState, useEffect } from 'react'
import './onlinefriend.css'

const OnlineFriend = ({id}) => {

      const [online, setOnline] = useState([]) 

      async function getOnline(id_xat){
            const url = `https://oceanbot.net/online.php?id=${id_xat}` 

            try{
                  const response = await fetch(url) 
                  const result = await response.json()
                  setOnline(result)
            }
            catch(err){
                  console.log('Error: ' + err)
            }
      }

      id.replace('M', '000000')

      useEffect(() => {
            getOnline(id)
      }, [id])

      if(online.length === 0) return 

      return (
            <div className={online.status === 'online' ? "online_friend green" : "online_friend red"}></div>
      )
}

export default OnlineFriend
